import React, { useState } from 'react';
import publicClient from '../utils/publicClient';

export default function DeleteAccount() {
  const [email, setEmail] = useState('');
  const [reason, setReason] = useState('');
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus('sending');
    try {
      await publicClient.post('/account/delete-request/', {
        email: email,
        reason: reason,
      });
      setStatus('sent');
    } catch {
      setStatus('error');
    }
  };

  const page = {
    minHeight: '100vh',
    background: '#0D1117',
    color: '#E2E8F0',
    fontFamily: 'Inter, sans-serif',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  };

  const card = {
    background: '#1A2236',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 20,
    padding: '40px 36px',
    width: '100%',
    maxWidth: 440,
  };

  const input = {
    width: '100%',
    padding: '12px 14px',
    background: '#0D1117',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 10,
    color: '#E2E8F0',
    fontSize: 14,
    outline: 'none',
    fontFamily: 'Inter, sans-serif',
    boxSizing: 'border-box',
  };

  if (status === 'sent') {
    return (
      <div style={page}>
        <div style={card}>
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✓</div>
            <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 22, marginBottom: 8 }}>
              Deletion Request Received
            </h2>
            <p style={{ color: '#9CA3AF', fontSize: 14, lineHeight: 1.7 }}>
              Your account deletion request has been submitted. We will process it within 30 days and send a confirmation to {email}.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={page}>
      <div style={card}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <h1 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: 24, marginBottom: 8 }}>
            Delete Your Account
          </h1>
          <p style={{ color: '#9CA3AF', fontSize: 14, lineHeight: 1.7 }}>
            Submit a request to delete your Multi Author account and all associated data. This action cannot be undone.
          </p>
        </div>

        <div style={{ textAlign: 'left', marginBottom: 24, fontSize: 13, color: '#9CA3AF', lineHeight: 1.7 }}>
          <p style={{ fontWeight: 600, color: '#E2E8F0', marginBottom: 4 }}>What gets deleted</p>
          <p style={{ marginBottom: 12 }}>
            Your account and login credentials, profile details, all workflows and generated
            content, any stored API keys, and your usage history.
          </p>
          <p style={{ fontWeight: 600, color: '#E2E8F0', marginBottom: 4 }}>What we keep</p>
          <p style={{ marginBottom: 12 }}>
            Billing records, for up to 7 years where tax and accounting law requires it, and
            anonymised usage statistics that cannot identify you.
          </p>
          <p style={{ fontWeight: 600, color: '#E2E8F0', marginBottom: 4 }}>How long it takes</p>
          <p>
            Requests are actioned within 30 days. We email a confirmation once deletion is complete.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#9CA3AF', marginBottom: 6 }}>
              Email address
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              style={input}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#9CA3AF', marginBottom: 6 }}>
              Reason (optional)
            </label>
            <textarea
              value={reason}
              onChange={e => setReason(e.target.value)}
              placeholder="Tell us why you're leaving..."
              rows={3}
              style={{ ...input, resize: 'vertical' }}
            />
          </div>

          {status === 'error' && (
            <div style={{
              background: 'rgba(220,38,38,0.1)',
              border: '1px solid rgba(220,38,38,0.3)',
              color: '#FCA5A5',
              borderRadius: 8,
              padding: '10px 14px',
              fontSize: 13,
              marginBottom: 16,
            }}>
              Something went wrong. Please try again.
            </div>
          )}

          <button
            type="submit"
            disabled={status === 'sending'}
            style={{
              width: '100%',
              padding: '13px',
              background: '#DC2626',
              color: 'white',
              border: 'none',
              borderRadius: 10,
              fontSize: 15,
              fontWeight: 700,
              cursor: status === 'sending' ? 'not-allowed' : 'pointer',
              fontFamily: 'Syne, sans-serif',
            }}
          >
            {status === 'sending' ? 'Sending...' : 'Request Account Deletion'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 12, color: '#4B5563' }}>
          Need help? Contact support@lojenterprise.com
        </p>
      </div>
    </div>
  );
}
